import AppBar from '@mui/material/AppBar';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import { alpha } from '@mui/material/styles';

import { BackButton } from 'reservations/base/components/BackButton';
import CloseButton from 'reservations/base/components/CloseButton';
import useIsDesktop from 'reservations/base/hooks/useIsDesktop';
import { useModal } from 'reservations/base/providers/ModalProvider';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const BaseDrawerContainer = ({
  isOpen,
  onClose,
  children
}: React.PropsWithChildren<Props>) => {
  const isDesktop = useIsDesktop();
  const anchor = isDesktop ? 'right' : 'bottom';
  const { back, modalStack } = useModal();
  const handleBack = modalStack.length > 1 ? back : null;

  return (
    <Drawer
      anchor={anchor}
      data-testid="base-drawer"
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: theme => ({
          width: isDesktop ? '450px' : '100%',
          height: '100%',
          backgroundColor: alpha(theme.palette.background.default, 1)
        })
      }}
    >
      <AppBar
        sx={theme => ({
          position: 'relative',
          boxShadow: 0,
          borderBottom: `1px solid ${theme.typography.body1.color}`,
          backgroundColor: theme.palette.background.default
        })}
      >
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {!!handleBack ? <BackButton onClick={handleBack} /> : <span />}
          <CloseButton
            onClick={onClose}
            iconSx={theme => ({ color: theme.typography.body1.color })}
          />
        </Toolbar>
      </AppBar>
      {children}
    </Drawer>
  );
};
